// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_GRADES_FINAL, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/grades/final';
import type { Params, FinalMarks } from 'app/dataTypes/FinalMarks.types';


export default function useFinalMarks({ klassId, studentId, date }: Params): FinalMarks {
  const { t } = useTranslation('app');
  const [finalMarks, setMarks] = useState<FinalMarks>({});

  const request = useCallback(async () => {
    const res = await api.request(GET_GRADES_FINAL, {
      error: t('request_dnevnik_marks_failed'),
      params: { klassId, studentId, date },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      setMarks(res);
    }
  }, [klassId, studentId, date, t]);

  useEffect(() => {
    request();
  }, [request]);

  return finalMarks;
}
